import { motion, useScroll, useTransform } from "framer-motion";
import { CalendarCheck } from "lucide-react";

const lines = [
  { text: "VOTRE TÉLÉPHONE,", chrome: false },
  { text: "RÉPARÉ", chrome: false },
  { text: "À DOMICILE.", chrome: true },
];

const CHROME_SOLID = "#0055FF";

export const Hero = ({ onNavigate }) => {
  const { scrollY } = useScroll();
  const yGlow = useTransform(scrollY, [0, 700], [0, -80]);

  return (
    <section
      id="accueil"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden pt-[80px]"
      data-testid="hero-section"
    >
      <motion.div
        style={{ y: yGlow }}
        className="pointer-events-none absolute -bottom-48 left-1/2 h-[520px] w-[1000px] -translate-x-1/2 rounded-full bg-[#0055FF] opacity-[0.16] blur-[160px]"
        aria-hidden="true"
      />
      <motion.div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <h1 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-[clamp(2.2rem,7vw,6.5rem)]">
          {lines.map((line, i) => (
            <span key={line.text} className="block overflow-hidden pb-1">
              <motion.span
                initial={{ y: "112%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.35 + i * 0.16, ease: [0.16, 1, 0.3, 1] }}
                className={`block ${line.chrome ? "" : "text-zinc-950"}`}
                style={line.chrome ? { color: CHROME_SOLID } : undefined}
              >
                {line.text}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.2, delay: 1.1, ease: [0.16, 1, 0.3, 1] }}
          className="blue-beam origin-left w-full max-w-xl mt-10"
          aria-hidden="true"
        />

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.2 }}
          className="mt-8 max-w-xl text-base md:text-lg leading-relaxed font-light text-zinc-600"
          data-testid="hero-subtitle"
        >
          Écran cassé, batterie qui ne tient plus, téléphone qui ne charge
          plus ? Un technicien SLH PHONE intervient à votre domicile ou au
          bureau.
          <br />
          Devis gratuit, réparation garantie 3 mois.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.35 }}
          className="mt-12 flex flex-wrap items-center gap-5"
        >
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            href="/reservation"
            className="flex items-center gap-3 rounded-full bg-[#25D366] px-9 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-white shadow-[0_0_24px_rgba(37,211,102,0.4)] hover:shadow-[0_0_36px_rgba(37,211,102,0.6)] transition-shadow duration-300"
            data-testid="hero-quote-cta"
          >
            <CalendarCheck className="h-4 w-4" />
            Réserver
          </motion.a>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => onNavigate("#services")}
            className="rounded-full border border-zinc-300 px-9 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-zinc-600 hover:border-zinc-900 hover:text-zinc-950 transition-colors duration-300"
            data-testid="hero-services-cta"
          >
            Nos réparations
          </motion.button>
        </motion.div>
      </motion.div>

    </section>
  );
};
